import _ from 'lodash';
import { call, put } from 'redux-saga/effects';
import api from 'services';
import * as cargoOrderActions from 'actions/cargoes/orders';
import * as actionTypes from 'constants/ActionTypes';
import mockOrder from 'mocks/cargo/order.json';
import moment from 'moment';

function* fillCargoType(clarified) {
    if (clarified.cargo[0].cargoType) {
        const responseCargoTypes = yield call(api.getCargoTypes);

        responseCargoTypes.data.push({
            _id: '59970a4513d689b67b8bf20d',
            name: 'Other',
        });

        const foundedType = responseCargoTypes.data.find(cargoType => cargoType._id === clarified.cargo[0].cargoType);

        if (foundedType) {
            clarified.cargo[0].cargoTypeName = foundedType.name;
        }
    }
}

function* createCargoesWithRanges(clarified) {
    const cargoes = [];
    let countOfCargoes = 1;
    const newCargo = _.cloneDeep(clarified.cargo[0]);

    if (newCargo.packing.pack.unitsVolume[1].value > 0
        || newCargo.packing.pack.unitsWeight[1].value > 0) {
        countOfCargoes = 2;
    }

    for (let i = 0; i < countOfCargoes; i++) {
        const packing = {
            pack: {
                unitsVolume: [{
                    value: newCargo.packing.pack.unitsVolume[i].value,
                    unit: newCargo.packing.pack.unitsVolume[i].unit,
                }],
                unitsWeight: [{
                    value: newCargo.packing.pack.unitsWeight[i].value,
                    unit: newCargo.packing.pack.unitsWeight[i].unit,
                }],
            },
        };

        cargoes.push({
            ...newCargo,
            sf: newCargo.packing.pack.sf,
            packing: {
                ...packing,
            },
        });
    }

    clarified.cargo = cargoes;
}

function* fillPorts(clarified) {
    if (clarified.loadingPort) {
        const { data } = yield call(api.getPort, { id: clarified.loadingPort });
        clarified.loadingPortName = data.name;
    }

    if (clarified.unloadingPort) {
        const { data } = yield call(api.getPort, { id: clarified.unloadingPort });
        clarified.unloadingPortName = data.name;
    }
}

function* createOrders(clarified) {
    const newClarified = _.cloneDeep(clarified);

    return newClarified.cargo.map((cargo) => {
        const loadingPorts = [];
        const unloadingPorts = [];

        newClarified.cargo = _.merge({}, mockOrder.cargo, cargo);

        if (newClarified.loadingPort) {
            const cancellingDate = moment(newClarified.cancellingDate).utc().startOf('day').toDate();
            const readinessDate = moment(newClarified.readinessDate).utc().startOf('day').toDate();
            const currentDate = moment().utc().startOf('day').toDate();


            loadingPorts.push({
                namePort: newClarified.loadingPortName,
                idPort: newClarified.loadingPort,
                cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                loadingPortDetails: '',
                cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
            });

            unloadingPorts.push({
                namePort: newClarified.unloadingPortName,
                idPort: newClarified.unloadingPort,
                unloadingPortDetails: '',
            });
        }

        return _.merge(
            {},
            mockOrder,
            newClarified,
            {
                loadingPorts,
                unloadingPorts,
            },
        );
    });
}

/**
 * Fill data from server
 * */
function* fillAndCreateCargoOrders(clarified) {
    const newClarified = _.cloneDeep(clarified);

    yield fillCargoType(newClarified);
    yield createCargoesWithRanges(newClarified);
    yield fillPorts(newClarified);
    return yield createOrders(newClarified);
}

export function* createCargoOrders(response) {
    let cargoOrders = [];

    if (response.status === 200) {
        if (response.data.clarified && response.data.clarified.length > 0) {
            for (let key = 0; key < response.data.clarified.length; key++) {
                try {
                    cargoOrders.push(yield call(fillAndCreateCargoOrders, response.data.clarified[key]));
                } catch (e) {
                    yield put({
                        type: actionTypes.ADD_NOTIFICATION,
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4,
                        },
                    });

                    console.error(e);
                }
            }
            // todo change structure of array

            cargoOrders = _.flatten(cargoOrders);

            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Created',
                    message: `The ${cargoOrders.length} cargo orders created`,
                    level: 'success',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 4,
                },
            });
            yield put(cargoOrderActions.createCargoOrders(cargoOrders));
        } else {
            yield put(cargoOrderActions.resetCargoOrders());

            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Warning',
                    message: 'The cargo orders did\'t create',
                    level: 'warning',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 4,
                },
            });
        }
    } else {
        yield put(cargoOrderActions.resetCargoOrders());

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Warning',
                message: 'The cargo orders did\'t create',
                level: 'warning',
                _id: new Date().getMilliseconds(),
                autoDismiss: 4,
            },
        });
    }
}



// WEBPACK FOOTER //
// ./app/sagas/cargoes/orders.js